module.exports = __webpack_public_path__ + "static/webcomponents-5367c74cfab3a30e48c27495c902f6b0.png";